import React, { useState } from 'react';
import { RESET_AMOUNTS } from '../data/mockData';

const ResetMoneyModal = ({ isOpen, onClose, onReset }) => {
  const [customAmount, setCustomAmount] = useState('');
  const [showCustom, setShowCustom] = useState(false);

  if (!isOpen) return null;

  const handleReset = (amount) => {
    onReset(amount);
    onClose();
    setShowCustom(false);
    setCustomAmount('');
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div 
        className="rounded-2xl p-6 w-96"
        style={{ 
          background: 'linear-gradient(145deg, #1a1a2e, #16213e)',
          border: '2px solid rgba(255,215,0,0.3)',
          boxShadow: '0 0 50px rgba(255,215,0,0.2)'
        }}
      >
        <div className="text-center mb-6">
          <div className="text-4xl mb-2">💰</div>
          <h2 className="text-xl font-bold" style={{ color: '#ffd700' }}>RELOAD CHIPS</h2>
          <p className="text-sm mt-1" style={{ color: '#888' }}>Select your buy-in amount</p>
        </div>
        
        <div className="grid grid-cols-3 gap-3 mb-4">
          {RESET_AMOUNTS.map((amount) => (
            <button
              key={amount}
              onClick={() => handleReset(amount)}
              className="py-4 rounded-xl font-bold transition-all hover:scale-105"
              style={{
                background: 'linear-gradient(145deg, #16a34a, #15803d)',
                color: 'white',
                boxShadow: '0 4px 15px rgba(34,197,94,0.3)'
              }}
            >
              ${amount.toLocaleString()}
            </button>
          ))}
        </div>

        {!showCustom ? (
          <button
            onClick={() => setShowCustom(true)}
            className="w-full py-3 rounded-xl font-bold text-sm transition-all hover:scale-105 mb-4"
            style={{
              background: 'rgba(255,215,0,0.1)',
              border: '1px solid rgba(255,215,0,0.3)',
              color: '#ffd700'
            }}
          >
            💵 CUSTOM AMOUNT
          </button>
        ) : (
          <div className="mb-4">
            <input
              type="number"
              value={customAmount}
              onChange={(e) => setCustomAmount(e.target.value)}
              placeholder="Enter amount"
              className="w-full px-4 py-3 rounded-xl mb-2 font-bold text-center"
              style={{
                background: 'rgba(0,0,0,0.3)',
                border: '2px solid rgba(255,215,0,0.3)',
                color: '#ffd700',
                outline: 'none'
              }}
            />
            <button
              onClick={() => handleReset(parseInt(customAmount) || 1000)}
              className="w-full py-3 rounded-xl font-bold transition-all hover:scale-105"
              style={{
                background: 'linear-gradient(145deg, #ffd700, #b8860b)',
                color: '#1a1a2e'
              }}
            >
              CONFIRM
            </button>
          </div>
        )}

        <button
          onClick={onClose}
          className="w-full py-3 rounded-xl font-bold transition-all hover:scale-105"
          style={{
            background: 'rgba(255,255,255,0.1)',
            color: '#888'
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ResetMoneyModal;
